@for (assignment of assignments$ | async; track assignment; let index = $index) {
  <button
    [class.active]="selectedAssignment && selectedAssignment === assignment.effectiveDate"
    (click)="handleClick(assignment)"
    >
    <span>{{ assignment.effectiveDate | date }}:</span>
    <strong>{{ assignment.profileHierarchy ? assignment.profileHierarchy : assignment.profile }}</strong>
  </button>
}
